import {
	reReportKindConstants
}from "./constants"
import {
	defAction
}from "../../../../helpers/defaultAction"
import api from "./api"

export const reReportKindActions = {
	clear,
	createReportKind,
	deleteReportKind,
	getAllPaged,
	restoreReportKind,
	updateReportKind
}

function clear(){
	return (dispatch) => {
		dispatch(request())
		function request(){
			return {
				type: reReportKindConstants.GetAllPaged.CLEAR
			}
		}
	}
}

function createReportKind(values){
	const dispatchObj = {
		constants : reReportKindConstants.CreateReportKind,
		service   : {
			func   : api.createReportKind,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteReportKind(values){
	const dispatchObj = {
		constants : reReportKindConstants.DeleteReportKind,
		service   : {
			func   : api.deleteReportKind,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getAllPaged(values){
	const dispatchObj = {
		constants : reReportKindConstants.GetAllPaged,
		service   : {
			func   : api.getAllPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restoreReportKind(values){
	const dispatchObj = {
		constants : reReportKindConstants.RestoreReportKind,
		service   : {
			func   : api.restoreReportKind,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function updateReportKind(values){
	const dispatchObj = {
		constants : reReportKindConstants.UpdateReportKind,
		service   : {
			func   : api.updateReportKind,
			params : values
		}
	}
	return defAction(dispatchObj)
}
